import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Grid2, Typography } from "@mui/material";
import type { FC } from "react";

const infoResources = Resources.base.order.detail.info;

//TODO poradie:
// stav, next action date, partner

export const OrderInfo: FC<{
	data?: OrderDetailResponseDto;
}> = ({ data }) => {
	const { t } = useResource();

	return (
		<Grid2 container spacing={2}>
			<Grid2 container size={{ xs: 12 }}>
				<BaseCard title={t(infoResources.titleCustomer)}>
					<Grid2 container>
						<Grid2 size={{ xs: 6 }} mt={0.5}>
							<Typography variant="body1" color="secondary" fontWeight={600}>
								{t(infoResources.name)}
							</Typography>
							<Typography variant="subtitle1" mb={0.5}>
								{data?.customer?.name}
							</Typography>
						</Grid2>

						<Grid2 size={{ xs: 6 }} mt={0.5}>
							<Typography variant="body1" color="secondary" fontWeight={600}>
								{t(infoResources.phone)}
							</Typography>
							<Typography variant="subtitle1" mb={0.5}>
								{data?.customer?.phone}
							</Typography>
						</Grid2>

						<Grid2 size={{ xs: 12 }} mt={0.5}>
							<Typography variant="body1" color="secondary" fontWeight={600}>
								{t(infoResources.email)}
							</Typography>
							<Typography variant="subtitle1" mb={0.5}>
								{data?.customer?.email}
							</Typography>
						</Grid2>
					</Grid2>
				</BaseCard>
			</Grid2>

			<Grid2 container size={{ xs: 12 }}>
				<BaseCard title={t(infoResources.titleGeneralInfo)}>
					<Grid2 container>
						<Grid2 size={{ xs: 12 }} mt={0.5}>
							<Typography variant="body1" color="secondary" fontWeight={600}>
								{t(infoResources.titleAddress)}
							</Typography>
							<Typography variant="subtitle1" mb={0.5}>
								{data?.address}
							</Typography>
						</Grid2>
					</Grid2>
				</BaseCard>
			</Grid2>
		</Grid2>
	);
};
